module.exports = __webpack_public_path__ + "static/media/icecream.478b4551.jpg";